/**
 * Public PIC landing (/q/:token) — no login.
 *
 * CR1 established the magic-link verify here. CR3 turns this into the live
 * questionnaire: GET /q/:token/questionnaire both verifies the link (signed,
 * non-expired, unused) AND returns the scoped questionnaire, so we render the
 * full answering experience directly. All link states (invalid / expired / used
 * / already-submitted / not-ready) are handled inside PicQuestionnaire.
 */
import { PicQuestionnaire } from './PicQuestionnaire';

export function PicLanding() {
  return <PicQuestionnaire />;
}
